<template>
  <div
    id="burger"
    class="burger lg:hidden"
    @click="open"
  >
    <button type="button" class="burger-button">
      <span class="burger-bar burger-bar__1"></span>
      <span class="burger-bar burger-bar__2"></span>
      <span class="burger-bar burger-bar__3"></span>
    </button>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations('layout', ['openSidebar']),

    open() {
      this.openSidebar();
    },
  },
};
</script>
<style lang="scss">
button:focus {
  outline: 0;
}

.burger {
  .burger-button {
    @apply bg-transparent relative block rounded-lg;
    height: 24px;
    width: 24px;
    .burger-bar {
      @apply bg-black absolute;
      left: 3px;
      width: 18px;
      height: 1.5px;
      margin-top: -1px;
    }
    .burger-bar__1 {
      transform: translateY(-6px);
    }

    .burger-bar__2 {
      transform-origin: 100% 50%;
    }

    .burger-bar__3 {
      transform: translateY(6px);
    }
  }
}
</style>
